/* istanbul ignore file */
import VerticalAddressInputLayout from '../../ui/layout/form/input/VerticalAddressInputLayout';
import AddressInput from './AddressInput';
import { AddressInputProps } from './AddressInput';

const VerticalAddressInput = (props: AddressInputProps) => {
  return (
    <VerticalAddressInputLayout>
      <AddressInput {...props} />
    </VerticalAddressInputLayout>
  );
};

export default VerticalAddressInput;
